/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Default_Background_Color_BlackInputs */

const en_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Black`)
};

const fr_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noir`)
};

const de_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwarz`)
};

const it_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nero`)
};

const ru_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черный`)
};

const es_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negro`)
};

const zh_cn2_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黑色`)
};

const ja_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黒`)
};

const hi_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`काला`)
};

const pt_pt2_options_display_default_background_color_black = /** @type {(inputs: Options_Display_Default_Background_Color_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preto`)
};

/**
* | output |
* | --- |
* | "Black" |
*
* @param {Options_Display_Default_Background_Color_BlackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_default_background_color_black = /** @type {((inputs?: Options_Display_Default_Background_Color_BlackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Default_Background_Color_BlackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_default_background_color_black(inputs)
	if (locale === "de") return de_options_display_default_background_color_black(inputs)
	if (locale === "it") return it_options_display_default_background_color_black(inputs)
	if (locale === "ru") return ru_options_display_default_background_color_black(inputs)
	if (locale === "es") return es_options_display_default_background_color_black(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_default_background_color_black(inputs)
	if (locale === "ja") return ja_options_display_default_background_color_black(inputs)
	if (locale === "hi") return hi_options_display_default_background_color_black(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_default_background_color_black(inputs)
	return en_options_display_default_background_color_black(inputs)
});